import React from "react";
import { Link } from "react-router-dom";
import iwclogo from "../images/iwc-logo-large.png";
import Interest from "../images/interest-rate.png";
import Growth from "../images/growth.png";
import Biz from "../images/business-and-finance.png";
import FAQAccordion from "../components/mini/FAQAccordion";
import InvestorInfoTwo from "../components/InvestorInfoTwo";
import TestimonialsTwo from "../components/TestimonialsTwo";
import OptionsBootcamp from "../components/OptionsBootcamp";
import ReviewsSection from "../components/ReviewsSection";
import WhatsappUs from "../components/WhatsappUs";
import VideoTestimonials from "../components/VideoTestimonials";

const HomeScreen = () => {
  return (
    <div className="w-full h-full">
      {/* Landing Hero Section (16:9 ratio) */}
      <section id="landing-hero" className="aspect-[16/9] w-full overflow-hidden">
        <div className="grid md:grid-cols-1 w-full h-full">
          <div className="place-self-center grid md:grid-rows-2 w-3/4 sm:p-2 md:p-2 lg:p-10">
            <img
              src={iwclogo}
              className="w-1/4 justify-self-center self-center mb-5"
              alt="IWC Logo"
            />
            <div>
              <h2 className="md:text-5xl text-3xl  md:text-center text-center mb-5 font-bold">
                Dedicated To Helping You Win In Your Trading
              </h2>
              <p className="md:text-2xl text-lg font-semibold md:text-center text-center mb-5">
                The Fulltime Option Trading Academy (FOTA) With Behind-The-Scenes
                Wealth Experts Who Closely Guide Our Community To Success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Investor Info Section */}
      <InvestorInfoTwo />

      {/* Benefits Section */}
      <section
        className="grid md:grid-cols-3 md:grid-rows-1 grid-rows-3 p-20 text-center mb-10 font-semibold h-auto"
        id="home-benefit"
      >
        <div>
          <div className="grid grid-cols-1">
            <img src={Growth} alt="growth" className="w-48 place-self-center" />
          </div>
          <div className="mt-5">
            <p className="text-2xl">Fundamental Knowledge</p>
            <p className="text-xl">Money and Wealth building.</p>
          </div>
        </div>
        <div>
          <div className="grid grid-cols-1">
            <img src={Interest} alt="interest" className="w-48 place-self-center" />
          </div>
          <div className="mt-5">
            <p className="text-2xl">Options Trading</p>
            <p className="text-xl">The real power of strategic investing.</p>
          </div>
        </div>
        <div>
          <div className="grid grid-cols-1">
            <img src={Biz} alt="business" className="w-48 place-self-center" />
          </div>
          <div className="mt-5">
            <p className="text-2xl">Key Trading Rules</p>
            <p className="text-xl">
              What every trader needs to follow to achieve accelerated portfolio growth.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Preview Section */}
      <section className="w-full px-6 py-10 bg-white text-black">
        <div className="text-center mb-8">
          <h2 className="text-center text-2xl md:text-4xl font-bold mb-4">
            HEAR WHAT OUR ALUMNI HAVE TO SAY
          </h2>
          <p className="text-center text-md md:text-lg font-semibold mb-6">
            Discover how our students are achieving success in their trading
            journey
          </p>
        </div>
        <div className="flex justify-center">
          <Link to="/testimonials">
            <button
              className="w-72 h-16 text-black text-left flex p-5 font-semibold items-center
           bg-primaryYellow hover:opacity-50 rounded-lg"
            >
              <div className="w-full grid grid-cols-2 items-center">
                <div className="self-center">
                  <p className="mt-1">VIEW ALL TESTIMONIALS</p>
                </div>
                <div className="flex items-center justify-end text-3xl">
                  <ion-icon name="arrow-forward-circle-outline"></ion-icon>
                </div>
              </div>
            </button>
          </Link>
        </div>
      </section>

      {/* Testimonials + Bootcamp + Whatsapp + Reviews */}
      <TestimonialsTwo />
      <OptionsBootcamp />
      <WhatsappUs />
      <VideoTestimonials />
      <ReviewsSection />
      <WhatsappUs />
      {/* <p>light blue bg and yellow font</p>
      <p>whatsapp starter message</p> */}


      {/* FAQ Section */}
      <section id="faq">
        <FAQAccordion />
      </section>
    </div>
  );
};

export default HomeScreen;
